import type { Link } from '@silvertours/common-landingpages-view';
import type { ReactNode } from 'react';

export const CTA_LINK_CONTENT_TYPE = 'ctaLink';

/**
 * Renders an embedded ctaLink as a button. The button component, its styles
 * and its click tracking live above `shared`, so the caller gives it in.
 */
export type RenderCtaLink = (link: Link) => ReactNode;

type CtaLinkFields = {
  href?: string;
  title?: string;
  target?: NonNullable<Link['target']>;
  masked?: boolean;
};

/**
 * The rich-text embed path bypasses backend domain mapping, so this mirrors
 * `mapOptionalLink` (back-data-landingpage properties.ts), which maps the
 * ctaLink of a module button: the label comes from `title`, and a link
 * without `href` or `title` is dropped. Keep the two rules the same, so an
 * embedded button and a module button show the same result for one entry.
 */
export const extractCtaLinkFromTarget = (target: unknown): Link | undefined => {
  const fields = (target as { fields?: CtaLinkFields } | undefined)?.fields;

  if (!fields?.href || !fields?.title) return undefined;

  const link: Link = { href: fields.href, label: fields.title };
  if (fields.masked) link.masked = fields.masked;
  if (fields.target) link.target = fields.target;

  return link;
};
